import React from "react";
import { connect } from 'react-redux';
import '../Common.scss';
import './Elevation1.scss';
import defaultImage from '../../../assets/default.png';

class ElevationDimensions extends React.Component<any, any>{

    render() {
        const { pageDetails } = this.props;
        const { elevationImage, carcassDepthList, loftSlabPresent, poojaMandir, metaData, dimensionTPattiData } = pageDetails || {};
        
        
        return (
            <div className="details-fit-page">
                <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}?ver=${new Date().getTime()}` :defaultImage} alt="" className="image-view" />
                    </div>
                </div>
                <div className="details-tables">
                    <div className="table-header">
                        {(pageDetails?.skirting || carcassDepthList || loftSlabPresent) && <div className="details-heading">CARCASS SPECIFICATIONS</div>}
                        <div className="details">
                            {
                            <React.Fragment>
                            {
                                pageDetails?.skirting?.map(skirting => {
                                    return <React.Fragment>{
                                        <div className="details-table">
                                            {
                                               skirting.heading ? <div className="table-heading">
                                               {skirting.heading ? skirting.heading: ""}
                                                </div>:""
                                            }
                                            {
                                                 skirting.details && Object.keys(skirting.details).map((key, index) => {
                                                    return (

                                                        <React.Fragment>
                                                            <div className="table-row">
                                                                        <div className="table-cell">
                                                                            {key?.toUpperCase()}
                                                                        </div>
                                                                        <div className="table-cell">
                                                                            {skirting.details[key]?.toString().toUpperCase()}
                                                                        </div>
                                                                    </div>
                                                        </React.Fragment>
                                                    );
                                                })
                                            }
                                        </div>
                                    }
                                    </React.Fragment>

                                })
                                }
                                {/* <React.Fragment>
                                    <div className="details-table">
                                           {
                                               heading ? <div className="table-heading">
                                               {heading ? heading: ""}
                                                </div>:""
                                           } 
                                        {

                                            details && Object.keys(details).map((key, index) => {
                                                    return (

                                                        <React.Fragment>
                                                            <div className="table-row">
                                                                        <div className="table-cell">
                                                                            {key?.toUpperCase()}
                                                                        </div>
                                                                        <div className="table-cell">
                                                                            {details[key]?.toString().toUpperCase()}
                                                                        </div>
                                                                    </div>
                                                        </React.Fragment>
                                                    );
                                                })
                                        }
                                    </div>
                                    {/* {
                                        softCloseSpecifications && softCloseSpecifications.length ? <div className="details-table">
                                             {
                                                <>
                                               <div className="table-heading">SOFT CLOSE DETAILS</div>
                                               <div className="table-row">
                                                        <div className="table-cell"><b>{roomType==="Kitchen"?`VERTICAL TYPE`:`SUBCATEGORY`}</b>
                                                        </div>
                                                        <div className="table-cell">
                                                            <b>DRAWERS</b>
                                                        </div>
                                                        <div className="table-cell">
                                                            <b>SHUTTERS</b>
                                                        </div>
                                                </div></>
                                             } */}
                                             {/* {
                                                (softCloseSpecifications || []).map((softClose, index) => {
                                                    const softCloseName = roomType==="Kitchen"?softClose?.verticalType:softClose?.subCategory;
                                                            return (
        
                                                                <React.Fragment>
                                                                    <div className="table-row">
                                                                                <div className="table-cell">
                                                                                    {softCloseName?.toString().toUpperCase()}
                                                                                </div>
                                                                                <div className="table-cell">
                                                                                   {softClose?.softcloseDrawers?.toString().toUpperCase()}
                                                                                </div>
                                                                                <div className="table-cell">
                                                                                   {softClose?.softcloseShutter?.toString().toUpperCase()}
                                                                                </div>
                                                                    </div>
                                                                </React.Fragment>
                                                            );
                                                     })
                                                } */}
                                    {
                                        carcassDepthList && carcassDepthList.length ? <div className="details-table">
                                             {
                                               <div className="table-heading">CARCASS DEPTHS</div>
                                             }
                                             {
                                                (carcassDepthList || []).map((carcase, index) => {
                                                            return (
                                                                    <div className="table-row">
                                                                                <div className="table-cell">
                                                                                    {carcase?.partType.toString().toUpperCase()}
                                                                                </div>
                                                                                <div className="table-cell">
                                                                                    {carcase?.depths.toString().toUpperCase()}
                                                                                </div>
                                                                    </div>
                                                            );
                                                     })
                                                }
                                        </div>:""
                                    }
                                    {
                                        loftSlabPresent && <div className="details-table">
                                             <div className="table-heading">LOFT SLAB PRESENT</div>
                                             <div className="table-row">
                                                    <div className="table-cell single-table-cell">
                                                        {loftSlabPresent.toString().toUpperCase()}
                                                    </div>                  
                                            </div>


                                        </div>
                                        
                                    }
                                    {
                                        (poojaMandir && poojaMandir?.length && poojaMandir[0]?.name) ? <div className="details-table">
                                            {
                                                <div className="table-heading">Pooja Mandir</div>
                                            }
                                            {
                                                (poojaMandir || []).map((data, index) => {
                                                    return (
                                                        <div className="table-row">
                                                            <div className="table-cell">
                                                                Name
                                                            </div>
                                                            <div className="table-cell">
                                                                {data?.name}
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div> : ""
                                    }
                                    {
                                        (metaData && metaData?.title?.length && metaData?.right?.length) ? <div className="details-table">
                                            {
                                                <div className="table-heading">{metaData?.title?.[0]}</div>
                                            }
                                            <div className="table-row">
                                                <p className="table-cell">Left</p>
                                                <div className="table-cell">
                                                    {metaData?.left?.map((e) => <span>{e}mm,</span>)}
                                                </div>
                                            </div>
                                            <div className="table-row">
                                                <p className="table-cell">Right</p>
                                                <div className="table-cell">
                                                    {metaData?.right?.map((e) => <span>{e}mm,</span>)}
                                                </div>
                                            </div>
                                            <div className="table-row">
                                                <p className="table-cell">Back</p>
                                                <div className="table-cell">
                                                    {metaData?.back?.map((e) => <span>{e}mm,</span>)}
                                                </div>
                                            </div>
                                        </div> : ""
                                    }
                                    {
                                        dimensionTPattiData && Object?.keys(dimensionTPattiData)?.length ? <div className="details-table">

                                            <div className="table-heading">T-Patti Details</div>
                                            <div className="table-row">
                                                <div className="table-cell">
                                                    Strip Length
                                                </div>
                                                <div className="table-cell">
                                                    Quantity
                                                </div>
                                            </div>
                                            {
                                                (Object?.entries(dimensionTPattiData) || []).map((data, key) => {
                                                    return (
                                                        <div className="table-row">
                                                            <div className="table-cell">
                                                                {data?.[0]}
                                                            </div>
                                                            <div className="table-cell">
                                                                {data?.[1]}
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            }
                                        </div> : ""
                                    }
                                </React.Fragment>

                            }
                        </div>
                    </div>
                </div>
            </div>

        )
    }

}

export default connect(
    (state: any) => ({
        roomInfoList: state.wizard.roomInfoList,
        roomName: state.wizard.roomName
    }),
    {
    }
)(ElevationDimensions);